// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    qrCodeLabel: {
        id: "apps.lens.components.lensSource.lensScanCode.qrCodeLabel",
        description: "Qr code label.",
        defaultMessage: "QR code",
    },
    openScanCode: {
        id: "apps.lens.components.lensSource.lensScanCode.openScanCode",
        description: "Open scan code.",
        defaultMessage: "Open {label}",
    },
    scanCodePreviewAlt: {
        id: "apps.lens.components.lensSource.lensScanCode.scanCodePreviewAlt",
        description: "Scan code preview alt.",
        defaultMessage: "{label} image preview",
    },
    scanCodeImageAlt: {
        id: "apps.lens.components.lensSource.lensScanCode.scanCodeImageAlt",
        description: "Scan code image alt.",
        defaultMessage: "{label} image",
    },
    scanCodeLoadError: {
        id: "apps.lens.components.lensSource.lensScanCode.scanCodeLoadError",
        description: "Scan code load error.",
        defaultMessage: "Unable to load QR code",
    },
    retryScanCode: {
        id: "apps.lens.components.lensSource.lensScanCode.retryScanCode",
        description: "Retry scan code.",
        defaultMessage: "Try again",
    },
    downloadScanCode: {
        id: "apps.lens.components.lensSource.lensScanCode.downloadScanCode",
        description: "Download scan code.",
        defaultMessage: "Download {label}",
    },
    downloadScanCodeError: {
        id: "apps.lens.components.lensSource.lensScanCode.downloadScanCodeError",
        description: "Download scan code error.",
        defaultMessage: "Unable to download QR code. Please try again.",
    },
});
